<template>
  <div class="pt-3">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="col-12">
              <div class="row">
                <div class="col-12 py-3 px-4 pt-4">
                  <div class="d-flex justify-content-between">
                    <h3
                      class="mt-0 mb-2 text-title-dashboard my-2 font-weight-bold"
                    >
                      Enviar nuevo Correo
                    </h3>
                  </div>
                  <form @submit.prevent="SendMail()">
                    <div class="row d-flex justify-content-center">
                      <div class="col-12 col-xl-7 col-md-10 px-0">
                        <div class="row">
                          <div class="col-12 pr-0 pl-0 py-0">
                            <label for="">Asunto</label>
                            <input
                              type="text"
                              placeholder="Asunto del correo"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.subject"
                              required
                            />
                          </div>
                          <div class="col-12 pl-0 pr-0 py-0">
                            <label for="">Destinatario</label>
                            <Multiselect
                              v-model="form.id_type_company"
                              :options="type_companys"
                              label="name"
                              placeholder="Seleccione una opción"
                              class="mt-1 mb-2"
                              required
                            />
                          </div>
                          <div
                            class="col-12 pl-0 pr-0 py-0"
                            v-if="form.id_type_company.id === 1"
                          >
                            <label for="">Agremiado</label>
                            <Multiselect
                              v-model="selectedUser"
                              :options="users"
                              label="user_compamy"
                              class="mt-1 mb-2"
                              placeholder="Seleccione una opción"
                              required
                            />
                          </div>
                          <div class="col-12 pl-0 pr-0 py-0">
                            <label for="">Mensaje</label>
                            <textarea
                              placeholder="Escribe aquí el mensaje"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.content"
                              required
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="d-flex justify-content-end w-100 mt-2">
                        <button
                          class="bg-primary text-white font-weight-normal border btn-outline-primary h5 btn mb-0 mt-md-0 mb-2 mt-1"
                          type="submit"
                        >
                          Enviar correo
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  components: {
    Multiselect
  },
  name: 'app',
  data() {
    return {
      form: {
        id_type_company: '',
        subject: '',
        content: ''
      },
      type_companys: [],
      users: [],
      selectedUser: ''
    }
  },
  methods: {
    ...mapActions(['createData', 'getData']),

    async SendMail() {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: '¿Deseas enviar este correo?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sí, enviar',
          cancelButtonText: 'Cancelar'
        })

        if (result.isConfirmed) {
          /* const payload =
            this.form.id_type_company.id &&
            (this.form.id_type_company.id !== 0) ^
              (this.form.id_type_company.id !== 1)
              ? {
                  url: 'auth/massive_mail',
                  data: {
                    id_type_company: 0,
                    subject: this.form.subject,
                    content: this.form.content,
                    id_user: this.selectedUser.id
                  }
                }
              : {
                  url: 'auth/massive_mail',
                  data: {
                    subject: this.form.subject,
                    content: this.form.content,
                    id_type_company: this.form.id_type_company.id
                  }
                }
            */
          let payload = {}

          if (
            this.form.id_type_company?.id === 1 && // Si el tipo de compañía es 1
            this.selectedUser?.id && // Y hay un usuario seleccionado
            this.selectedUser.id !== 'all' // Y el usuario seleccionado no es "all"
          ) {
            payload = {
              url: 'auth/massive_mail',
              data: {
                id_type_company: 0, // id_type_company se fija en 0
                subject: this.form.subject,
                content: this.form.content,
                id_user: this.selectedUser.id // Usuario específico
              }
            }
          } else {
            payload = {
              url: 'auth/massive_mail',
              data: {
                subject: this.form.subject,
                content: this.form.content,
                id_type_company: this.form.id_type_company?.id || 0 // Fallback a 0 si no existe id
              }
            }
          }

          const response = await this.createData(payload)

          if (response.code === 200) {
            Swal.fire({
              title: 'Correo enviado',
              text: 'El correo se ha enviado exitosamente.',
              icon: 'success',
              confirmButtonText: 'OK'
            })
            this.resetForm()
          } else {
            Swal.fire({
              title: 'Error',
              text: 'Hubo un problema al enviar el correo.',
              icon: 'error',
              confirmButtonText: 'OK'
            })
          }
        }
      } catch (error) {
        console.error('Error al enviar el correo:', error)
        Swal.fire({
          title: 'Error',
          text: 'Hubo un problema al enviar el correo.',
          icon: 'error',
          confirmButtonText: 'OK'
        })
      }
    },
    loadUsers() {
      const form = {
        url: 'user/all',
        params: { active: 1, id_type_user_status: 2 }
      }
      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.users = response.data
              .filter(
                (user) =>
                  user.company !== null &&
                  user.id_company !== 0 &&
                  user.id_company !== null
              )
              .map((user) => ({
                ...user,
                user_compamy: user.company.company_name + ' - ' + user.email
              }))
            this.users.push({ id: 'all', user_compamy: 'Todos' })
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },

    loadCompanyTypes() {
      const form = {
        url: 'type_company/all',
        params: { active: 1 }
      }
      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.type_companys = response.data.map((item) => ({
              id: item.id,
              name: item.name === 'Indefinida' ? 'Individual/Otros' : item.name
            }))
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },

    resetForm() {
      this.form = {
        id_type_company: '',
        subject: '',
        content: ''
      }
    }
  },
  mounted() {
    this.loadCompanyTypes()
    this.loadUsers()
  }
}
</script>

<style>
.filepond--credits {
  display: none !important;
}
</style>
